import { render, staticRenderFns } from "./SmsBroadcastComplianceModal.vue?vue&type=template&id=b5c6410a&scoped=true"
import script from "./SmsBroadcastComplianceModal.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastComplianceModal.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastComplianceModal.vue?vue&type=style&index=0&id=b5c6410a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c6410a",
  null
  
)

export default component.exports